/**
 * Represents objects containing location media data, specifically a gallery field.
 *
 * @example
 * // Works with Supplier objects
 * getLocationGallery(supplier)
 * // Also works with partial objects, API responses, or test data
 * getLocationGallery({ gallery: ['img1.jpg', null, 'img2.jpg'] })
 */
interface LocationMediaLike {
  gallery?: Array<string | null | undefined> | null;
}

const isGalleryImageName = (value: string | null | undefined): value is string =>
  typeof value === 'string' && value.length > 0;

/**
 * Normalizes the raw gallery array from a location API response,
 * deduplicating and removing null/undefined entries.
 *
 * @param location - An object containing an optional raw gallery field.
 * @returns A deduplicated array of non-null gallery image filenames.
 */
export const getLocationGallery = (location: LocationMediaLike): string[] =>
  Array.from(new Set((location.gallery ?? []).filter(isGalleryImageName)));

